/* ==========================================================================
   Northpaw — The Dog Face
   No dependencies. Everything is a custom element or a small delegated handler.
   ========================================================================== */
(function () {
  'use strict';

  var CFG = window.Northpaw || (window.Northpaw = { routes: {}, settings: {}, strings: {} });
  var R = CFG.routes;
  var S = CFG.settings;
  var T = CFG.strings;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isDesktop = function () { return window.matchMedia('(min-width: 769px)').matches; };

  /* ---------------------------------------------------------------- helpers */

  function announce(msg) {
    var el = document.getElementById('live-region');
    if (el) { el.textContent = ''; window.setTimeout(function () { el.textContent = msg; }, 60); }
  }

  function itemCount(n) {
    var template = n === 1 ? T.itemCountOne : T.itemCountOther;
    return String(template || '{{ count }} items').replace(/\{\{\s*count\s*\}\}/, n);
  }

  function money(cents) {
    var fmt = S.moneyFormat || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    return fmt.replace(/\{\{\s*amount\s*\}\}/, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, String(Math.round(cents / 100)));
  }

  function debounce(fn, wait) {
    var t;
    return function () {
      var ctx = this, args = arguments;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]):not([type=hidden]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';

  function trapFocus(root) {
    function onKey(e) {
      if (e.key !== 'Tab') return;
      var items = Array.prototype.filter.call(root.querySelectorAll(FOCUSABLE), function (el) {
        return el.offsetParent !== null;
      });
      if (!items.length) return;
      var first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    root.addEventListener('keydown', onKey);
    return function () { root.removeEventListener('keydown', onKey); };
  }

  var scrollLocks = 0;
  function lockScroll(on) {
    scrollLocks = Math.max(0, scrollLocks + (on ? 1 : -1));
    document.documentElement.style.overflow = scrollLocks ? 'hidden' : '';
  }

  function fetchJSON(url, opts) {
    return fetch(url, opts).then(function (r) {
      if (!r.ok) return r.json().then(function (d) { throw d; }, function () { throw new Error(r.statusText); });
      return r.json();
    });
  }

  /* ------------------------------------------------------------ cart bridge */

  var Cart = {
    subscribers: [],
    onChange: function (fn) { Cart.subscribers.push(fn); },
    publish: function (cart) { Cart.subscribers.forEach(function (fn) { fn(cart); }); },
    get: function () { return fetchJSON(R.cart + '.js'); },
    add: function (formData) {
      return fetchJSON(R.cartAdd + '.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData
      }).then(function (item) {
        return Cart.get().then(function (cart) { Cart.publish(cart); return item; });
      });
    },
    change: function (body) {
      return fetchJSON(R.cartChange + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      }).then(function (cart) { Cart.publish(cart); return cart; });
    }
  };
  CFG.Cart = Cart;

  /* -------------------------------------------------------------- layer controller
     Generic slide-out / overlay controller shared by nav, search and lightbox. */

  var Layer = {
    open: null,
    show: function (el, opener) {
      if (Layer.open === el) return;
      if (Layer.open) Layer.hide();
      Layer.open = el;
      el._opener = opener || document.activeElement;
      el.classList.add('is-open');
      el.removeAttribute('aria-hidden');
      var scrim = document.getElementById('layer-scrim');
      if (scrim && el.dataset.scrim !== 'false') scrim.classList.add('is-open');
      lockScroll(true);
      el._untrap = trapFocus(el);
      var target = el.querySelector('[data-autofocus]') || el.querySelector(FOCUSABLE);
      if (target) window.setTimeout(function () { target.focus(); }, 60);
      document.querySelectorAll('[aria-controls="' + el.id + '"]').forEach(function (b) {
        b.setAttribute('aria-expanded', 'true');
      });
    },
    hide: function () {
      var el = Layer.open;
      if (!el) return;
      Layer.open = null;
      el.classList.remove('is-open');
      el.setAttribute('aria-hidden', 'true');
      var scrim = document.getElementById('layer-scrim');
      if (scrim) scrim.classList.remove('is-open');
      lockScroll(false);
      if (el._untrap) el._untrap();
      document.querySelectorAll('[aria-controls="' + el.id + '"]').forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
      });
      if (el._opener && document.contains(el._opener)) el._opener.focus();
    }
  };
  CFG.Layer = Layer;

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-layer-open]');
    if (opener) {
      var el = document.getElementById(opener.getAttribute('aria-controls') || opener.dataset.layerOpen);
      if (el) { e.preventDefault(); Layer.open === el ? Layer.hide() : Layer.show(el, opener); }
      return;
    }
    if (e.target.closest('[data-layer-close]') || e.target.id === 'layer-scrim') {
      Layer.hide();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && Layer.open) Layer.hide();
  });

  /* ------------------------------------------------------- sticky masthead */

  function initStickyHeader() {
    var host = document.querySelector('[data-sticky-header]');
    if (!host) return;
    var clone = host.cloneNode(true);
    clone.classList.add('masthead--pinned');
    clone.classList.remove('masthead--over');
    clone.removeAttribute('data-sticky-header');
    clone.setAttribute('data-pinned-header', '');
    clone.querySelectorAll('[id]').forEach(function (n) { n.removeAttribute('id'); });
    host.parentNode.insertBefore(clone, host.nextSibling);

    var lastY = window.scrollY;
    var threshold = host.offsetHeight + 60;
    var ticking = false;

    function update() {
      var y = window.scrollY;
      var goingUp = y < lastY;
      clone.classList.toggle('is-shown', y > threshold && goingUp);
      lastY = y;
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }, { passive: true });
  }

  /* --------------------------------------------------------- reveal on view */

  function initReveal() {
    var nodes = document.querySelectorAll('[data-reveal]');
    if (!nodes.length) return;
    if (reduceMotion || !S.motion || !('IntersectionObserver' in window)) {
      nodes.forEach(function (n) { n.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var delay = parseInt(el.dataset.revealDelay || '0', 10);
        window.setTimeout(function () { el.classList.add('is-in'); }, delay);
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    nodes.forEach(function (n) { io.observe(n); });
  }

  /* ------------------------------------------------------------- accordions */

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.accordion__trigger');
    if (!trigger) return;
    var panel = document.getElementById(trigger.getAttribute('aria-controls'));
    if (!panel) return;
    var open = trigger.getAttribute('aria-expanded') === 'true';
    trigger.setAttribute('aria-expanded', String(!open));
    if (open) { panel.removeAttribute('data-open'); }
    else { panel.setAttribute('data-open', ''); }
  });

  /* ------------------------------------------------------ disclosure widget */

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('.disclosure__toggle');
    document.querySelectorAll('.disclosure__list').forEach(function (list) {
      var own = toggle && toggle.parentElement.contains(list);
      if (!own) {
        list.hidden = true;
        var t = list.parentElement.querySelector('.disclosure__toggle');
        if (t) t.setAttribute('aria-expanded', 'false');
      }
    });
    if (!toggle) return;
    e.preventDefault();
    var list = toggle.parentElement.querySelector('.disclosure__list');
    if (!list) return;
    var show = list.hidden;
    list.hidden = !show;
    toggle.setAttribute('aria-expanded', String(show));
  });

  document.addEventListener('click', function (e) {
    var opt = e.target.closest('[data-locale-value]');
    if (!opt) return;
    e.preventDefault();
    var form = opt.closest('form');
    if (!form) return;
    var input = form.querySelector('[name="' + opt.dataset.localeInput + '"]');
    if (input) input.value = opt.dataset.localeValue;
    form.submit();
  });

  /* ------------------------------------------------------ product card hovers */

  var CardMedia = {
    hydrate: function (card) {
      if (card._hydrated) return;
      card._hydrated = true;
      card.querySelectorAll('img[data-src]').forEach(function (img) {
        if (img.dataset.srcset) img.srcset = img.dataset.srcset;
        img.src = img.dataset.src;
        img.removeAttribute('data-src');
        img.removeAttribute('data-srcset');
      });
    },
    start: function (card) {
      var frames = card.querySelectorAll('.card__frame');
      if (frames.length < 2 || card._timer) return;
      CardMedia.hydrate(card);
      var i = 0;
      card._timer = window.setInterval(function () {
        frames[i].classList.remove('card__frame--on');
        if (i === 0) frames[0].classList.add('card__frame--off');
        i = (i + 1) % frames.length;
        frames[i].classList.add('card__frame--on');
        if (i === 0) frames[0].classList.remove('card__frame--off');
      }, 1050);
    },
    stop: function (card) {
      if (!card._timer) return;
      window.clearInterval(card._timer);
      card._timer = null;
      card.querySelectorAll('.card__frame').forEach(function (f, idx) {
        f.classList.toggle('card__frame--on', idx === 0);
        f.classList.remove('card__frame--off');
      });
    }
  };

  /* Hover frames only run on desktop with a real pointer. Phones and tablets keep
     the first image only, so scrolling never pulls the extra frames. */
  var canHover = function () { return window.matchMedia('(hover: hover)').matches; };

  function initCards(scope) {
    var cards = (scope || document).querySelectorAll('[data-card-cycle]');
    if (!cards.length || reduceMotion || !isDesktop() || !canHover()) return;
    cards.forEach(function (card) {
      if (card._bound) return;
      card._bound = true;
      card.addEventListener('mouseenter', function () { CardMedia.start(card); });
      card.addEventListener('mouseleave', function () { CardMedia.stop(card); });
    });
  }

  /* ------------------------------------------------------- <np-slideshow> */

  class Slideshow extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('[data-slides]');
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      if (!this.viewport || this.slides.length < 2) return;
      this.index = 0;
      this.dots = Array.from(this.querySelectorAll('[data-dot]'));

      this.querySelectorAll('[data-prev]').forEach((b) => b.addEventListener('click', () => this.go(this.index - 1)));
      this.querySelectorAll('[data-next]').forEach((b) => b.addEventListener('click', () => this.go(this.index + 1)));
      this.dots.forEach((d, i) => d.addEventListener('click', () => this.go(i)));

      this.viewport.addEventListener('scroll', debounce(() => {
        const i = Math.round(this.viewport.scrollLeft / this.viewport.clientWidth);
        if (i !== this.index) { this.index = i; this.sync(); }
      }, 90), { passive: true });

      if (this.dataset.autoplay === 'true' && !reduceMotion) {
        this.delay = parseInt(this.dataset.speed || '7', 10) * 1000;
        this.addEventListener('mouseenter', () => this.pause());
        this.addEventListener('mouseleave', () => this.play());
        this.addEventListener('focusin', () => this.pause());
        document.addEventListener('visibilitychange', () => (document.hidden ? this.pause() : this.play()));
        this.play();
      }
      this.sync();
    }

    disconnectedCallback() { this.pause(); }

    play() { this.pause(); this.timer = window.setInterval(() => this.go(this.index + 1), this.delay); }
    pause() { if (this.timer) { window.clearInterval(this.timer); this.timer = null; } }

    go(i) {
      const n = this.slides.length;
      this.index = ((i % n) + n) % n;
      this.viewport.scrollTo({ left: this.index * this.viewport.clientWidth, behavior: reduceMotion ? 'auto' : 'smooth' });
      this.sync();
    }

    sync() {
      this.slides.forEach((s, i) => {
        s.setAttribute('aria-hidden', String(i !== this.index));
        s.querySelectorAll('a,button').forEach((el) => {
          if (i === this.index) el.removeAttribute('tabindex');
          else el.setAttribute('tabindex', '-1');
        });
      });
      this.dots.forEach((d, i) => d.setAttribute('aria-current', String(i === this.index)));
    }
  }
  customElements.define('np-slideshow', Slideshow);

  /* ----------------------------------------------------- <np-gallery> (PDP) */

  class Gallery extends HTMLElement {
    connectedCallback() {
      this.stage = this.querySelector('[data-stage]');
      this.slides = Array.from(this.querySelectorAll('[data-media]'));
      this.thumbs = Array.from(this.querySelectorAll('[data-thumb]'));
      this.stacked = this.dataset.layout === 'stacked';

      this.thumbs.forEach((t, i) => t.addEventListener('click', (e) => { e.preventDefault(); this.show(i); }));

      this.prevBtn = this.querySelector('[data-gallery-prev]');
      this.nextBtn = this.querySelector('[data-gallery-next]');
      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.step(-1));
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.step(1));

      if (!this.stacked && this.stage) {
        this.stage.addEventListener('scroll', debounce(() => {
          const i = Math.round(this.stage.scrollLeft / this.stage.clientWidth);
          this.mark(i);
        }, 90), { passive: true });
      }

      if (this.dataset.zoom === 'true') {
        this.addEventListener('click', (e) => {
          const img = e.target.closest('[data-zoomable]');
          if (!img) return;
          e.preventDefault();
          const idx = this.slides.indexOf(img.closest('[data-media]'));
          openLightbox(this.slides.map((s) => ({
            src: s.dataset.full || s.querySelector('img') && s.querySelector('img').currentSrc,
            alt: (s.querySelector('img') || {}).alt || ''
          })), Math.max(0, idx));
        });
      }

      document.addEventListener('np:variant', (e) => {
        if (e.detail.sectionId !== this.dataset.section) return;
        const id = e.detail.mediaId;
        if (!id) return;
        const i = this.slides.findIndex((s) => s.dataset.mediaId === String(id));
        if (i > -1) this.show(i, e.detail.initial);
      });

      this.mark(0);
    }

    show(i, instant) {
      const target = this.slides[i];
      if (!target) return;
      const behavior = instant || reduceMotion ? 'auto' : 'smooth';
      if (this.stacked) {
        target.scrollIntoView({ behavior, block: 'center' });
      } else if (this.stage) {
        this.stage.scrollTo({ left: i * this.stage.clientWidth, behavior });
      }
      this.mark(i);
    }

    mark(i) {
      this.current = i;
      this.thumbs.forEach((t, n) => t.setAttribute('aria-current', String(n === i)));
    }

    step(dir) {
      const count = this.slides.length;
      if (!count) return;
      const next = ((this.current || 0) + dir + count) % count;
      this.show(next);
    }
  }
  customElements.define('np-gallery', Gallery);

  /* ------------------------------------------------------------- lightbox */

  var lightboxState = { items: [], index: 0 };

  function openLightbox(items, index) {
    var box = document.getElementById('lightbox');
    if (!box || !items.length) return;
    lightboxState.items = items.filter(function (i) { return i.src; });
    lightboxState.index = index || 0;
    paintLightbox();
    Layer.show(box);
  }

  function paintLightbox() {
    var box = document.getElementById('lightbox');
    if (!box) return;
    var item = lightboxState.items[lightboxState.index];
    if (!item) return;
    var img = box.querySelector('img');
    img.src = item.src;
    img.alt = item.alt || '';
    var multiple = lightboxState.items.length > 1;
    box.querySelectorAll('.lightbox__prev,.lightbox__next').forEach(function (b) { b.hidden = !multiple; });
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('.lightbox__next')) {
      lightboxState.index = (lightboxState.index + 1) % lightboxState.items.length;
      paintLightbox();
    } else if (e.target.closest('.lightbox__prev')) {
      lightboxState.index = (lightboxState.index - 1 + lightboxState.items.length) % lightboxState.items.length;
      paintLightbox();
    }
  });

  document.addEventListener('keydown', function (e) {
    var box = document.getElementById('lightbox');
    if (!box || Layer.open !== box) return;
    if (e.key === 'ArrowRight') { lightboxState.index = (lightboxState.index + 1) % lightboxState.items.length; paintLightbox(); }
    if (e.key === 'ArrowLeft') { lightboxState.index = (lightboxState.index - 1 + lightboxState.items.length) % lightboxState.items.length; paintLightbox(); }
  });

  /* ------------------------------------------------------- <np-variants> */

  class Variants extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.section;
      this.productUrl = this.dataset.url;
      this.updateHistory = this.dataset.history === 'true';
      const data = this.querySelector('[data-variant-json]');
      this.variants = data ? JSON.parse(data.textContent) : [];
      this.idInput = this.querySelector('[name="id"]');
      this.addEventListener('change', (e) => {
        if (e.target.matches('[data-option-input]')) this.select();
      });
      this.select(true);
    }

    currentOptions() {
      return Array.from(this.querySelectorAll('[data-option-group]')).map((group) => {
        const checked = group.querySelector('[data-option-input]:checked') || group.querySelector('select[data-option-input]');
        return checked ? checked.value : null;
      });
    }

    match(options) {
      return this.variants.find(function (v) {
        return options.every(function (val, i) { return val === null || v.options[i] === val; });
      });
    }

    select(initial) {
      const options = this.currentOptions();
      const variant = this.match(options);
      this.paintAvailability(options);

      if (!variant) {
        this.setBuyState(null);
        return;
      }
      if (this.idInput) this.idInput.value = variant.id;
      this.setBuyState(variant);
      this.paintPrice(variant);

      if (!initial && this.updateHistory && window.history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
      document.dispatchEvent(new CustomEvent('np:variant', {
        detail: { sectionId: this.sectionId, variant: variant, mediaId: variant.featured_media_id, initial: !!initial }
      }));
    }

    paintAvailability(options) {
      const groups = Array.from(this.querySelectorAll('[data-option-group]'));
      groups.forEach((group, level) => {
        group.querySelectorAll('[data-option-input]').forEach((input) => {
          const probe = options.slice();
          probe[level] = input.value;
          for (let i = level + 1; i < probe.length; i++) probe[i] = null;
          const exists = this.variants.some((v) =>
            probe.every((val, i) => val === null || v.options[i] === val) && v.available
          );
          const label = group.querySelector('label[for="' + input.id + '"]');
          if (label) label.classList.toggle('is-unavailable', !exists);
          input.dataset.unavailable = String(!exists);
        });
      });
    }

    paintPrice(variant) {
      const host = this.closest('[data-product-root]') || document;
      const price = host.querySelector('[data-price]');
      if (price) {
        var regularLabel = '<span class="visually-hidden">' + price.dataset.labelRegular + '</span>';
        let html = '<span class="' + (variant.compare_at_price > variant.price ? 'is-sale' : '') + '">' + money(variant.price) + '</span>';
        if (variant.compare_at_price > variant.price) {
          html = regularLabel + '<del>' + money(variant.compare_at_price) + '</del>' + '<span class="visually-hidden">' + price.dataset.labelSale + '</span>' + html;
        } else {
          html = regularLabel + html;
        }
        price.innerHTML = html;
      }
      const unit = host.querySelector('[data-unit-price]');
      if (unit) {
        if (variant.unit_price) {
          unit.hidden = false;
          unit.textContent = money(variant.unit_price) + ' / ' +
            (variant.unit_price_measurement.reference_value !== 1 ? variant.unit_price_measurement.reference_value : '') +
            variant.unit_price_measurement.reference_unit;
        } else {
          unit.hidden = true;
        }
      }
      const sku = host.querySelector('[data-sku]');
      if (sku) sku.textContent = variant.sku || '';
    }

    setBuyState(variant) {
      const host = this.closest('[data-product-root]') || document;
      const btn = host.querySelector('[data-add-button]');
      const label = btn && btn.querySelector('[data-add-label]');
      if (!btn) return;
      if (!variant) {
        btn.disabled = true;
        if (label) label.textContent = T.unavailable || 'Unavailable';
      } else if (!variant.available) {
        btn.disabled = true;
        if (label) label.textContent = T.soldOut || 'Sold out';
      } else {
        btn.disabled = false;
        if (label) label.textContent = T.addToCart || 'Add to cart';
      }
    }
  }
  customElements.define('np-variants', Variants);

  /* ---------------------------------------------------- add to cart forms */

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('[data-add-form]')) return;
    if (S.cartMode !== 'sticky') return; // full page post when there is no tray
    e.preventDefault();
    var btn = form.querySelector('[data-add-button]');
    var label = btn && btn.querySelector('[data-add-label]');
    var original = label ? label.textContent : '';
    if (btn) btn.disabled = true;
    if (label) label.textContent = T.adding || 'Adding…';

    Cart.add(new FormData(form)).then(function () {
      if (label) label.textContent = T.added || 'Added';
      announce(T.added || 'Added to cart');
      window.setTimeout(function () {
        if (label) label.textContent = original;
        if (btn) btn.disabled = false;
      }, 1600);
    }).catch(function (err) {
      if (label) label.textContent = original;
      if (btn) btn.disabled = false;
      var msg = (err && (err.description || err.message)) || T.cartError;
      var slot = form.querySelector('[data-add-error]');
      if (slot) { slot.textContent = msg; slot.hidden = false; }
      announce(msg);
    });
  });

  /* ---------------------------------------------------------- sticky tray */

  function initTray() {
    var tray = document.querySelector('[data-tray]');
    if (!tray) return;
    var count = tray.querySelector('[data-tray-count]');
    var total = tray.querySelector('[data-tray-total]');

    function measure() {
      document.documentElement.style.setProperty('--tray-h', tray.offsetHeight + 'px');
    }

    function paint(cart) {
      tray.hidden = cart.item_count === 0;
      if (count) count.textContent = itemCount(cart.item_count);
      if (total) total.textContent = money(cart.total_price);
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
        el.hidden = cart.item_count === 0;
      });
      measure();
    }

    Cart.onChange(paint);
    measure();
    window.addEventListener('resize', debounce(measure, 150), { passive: true });
  }

  /* ------------------------------------------------------------- cart page */

  function initCartPage() {
    var root = document.querySelector('[data-cart-page]');
    if (!root) return;

    root.addEventListener('change', function (e) {
      var input = e.target.closest('[data-line-qty]');
      if (!input) return;
      updateLine(input.dataset.lineKey, parseInt(input.value, 10));
    });

    root.addEventListener('click', function (e) {
      var remove = e.target.closest('[data-line-remove]');
      if (remove) {
        e.preventDefault();
        updateLine(remove.dataset.lineKey, 0);
        return;
      }
      var step = e.target.closest('[data-qty-step]');
      if (step) {
        var input = step.parentElement.querySelector('input');
        var next = Math.max(0, parseInt(input.value, 10) + parseInt(step.dataset.qtyStep, 10));
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    function updateLine(key, quantity) {
      root.setAttribute('aria-busy', 'true');
      Cart.change({ id: key, quantity: quantity })
        .then(function () { return fetch(R.cart + '?section_id=' + root.dataset.sectionId); })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-cart-page]');
          if (fresh) root.innerHTML = fresh.innerHTML;
          root.removeAttribute('aria-busy');
        })
        .catch(function () {
          root.removeAttribute('aria-busy');
          window.location.reload();
        });
    }
  }

  /* -------------------------------------------------- quantity steppers */

  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-qty-step]');
    if (!step || step.closest('[data-cart-page]')) return;
    var input = step.parentElement.querySelector('input');
    if (!input) return;
    var min = parseInt(input.min || '1', 10);
    input.value = Math.max(min, parseInt(input.value || '1', 10) + parseInt(step.dataset.qtyStep, 10));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* --------------------------------------------------- predictive search */

  function initSearch() {
    var host = document.querySelector('[data-predictive]');
    if (!host || !S.predictive) return;
    var input = host.querySelector('input[type="search"]');
    var results = host.querySelector('[data-predictive-results]');
    if (!input || !results) return;
    var controller;

    var run = debounce(function () {
      var q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; input.setAttribute('aria-expanded', 'false'); return; }
      if (controller) controller.abort();
      controller = new AbortController();
      var url = R.predictive + '?q=' + encodeURIComponent(q) +
        '&resources[type]=' + encodeURIComponent(S.predictiveScope || 'product') +
        '&resources[limit]=6&resources[options][unavailable_products]=last&section_id=predictive-search';
      fetch(url, { signal: controller.signal })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-predictive-results]');
          results.innerHTML = fresh ? fresh.innerHTML : '';
          input.setAttribute('aria-expanded', 'true');
        })
        .catch(function (err) { if (err.name !== 'AbortError') results.innerHTML = ''; });
    }, 250);

    input.addEventListener('input', run);
  }

  /* --------------------------------------------------------------- facets */

  function initFacets() {
    var form = document.querySelector('[data-facet-form]');
    if (!form) return;
    var target = document.querySelector('[data-facet-results]');

    function submitFacets() {
      var params = new URLSearchParams(new FormData(form));
      Array.from(params.keys()).forEach(function (k) { if (!params.get(k)) params.delete(k); });
      var url = form.action.split('?')[0] + '?' + params.toString();
      form.setAttribute('aria-busy', 'true');
      fetch(url + '&section_id=' + form.dataset.sectionId)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var freshResults = doc.querySelector('[data-facet-results]');
          var freshForm = doc.querySelector('[data-facet-form]');
          if (target && freshResults) target.innerHTML = freshResults.innerHTML;
          if (freshForm) form.innerHTML = freshForm.innerHTML;
          form.removeAttribute('aria-busy');
          window.history.replaceState({}, '', url);
          initCards(target || document);
          initReveal();
        })
        .catch(function () { window.location.href = url; });
    }

    form.addEventListener('change', submitFacets);
    form.addEventListener('submit', function (e) { e.preventDefault(); submitFacets(); });
  }

  /* ------------------------------------------------------ sort select --- */

  document.addEventListener('change', function (e) {
    var select = e.target.closest('[data-sort]');
    if (!select) return;
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', select.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  /* --------------------------------------------- product recommendations */

  function initRelated(scope) {
    (scope || document).querySelectorAll('[data-related]').forEach(function (el) {
      if (el._loaded || !el.dataset.url) return;
      el._loaded = true;
      fetch(el.dataset.url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-related]');
          if (!fresh) return;
          el.innerHTML = fresh.innerHTML;
          initCards(el);
          initReveal();
        })
        .catch(function () {});
    });
  }

  /* ------------------------------------------- confirm-before-destroy links */

  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-confirm]');
    if (!el) return;
    if (!window.confirm(el.dataset.confirm)) e.preventDefault();
  });

  /* -------------------------------------------------------------- startup */

  function boot() {
    initRelated();
    initStickyHeader();
    initReveal();
    initCards();
    initTray();
    initCartPage();
    initSearch();
    initFacets();

    if (S.cartMode === 'sticky') {
      Cart.get().then(function (cart) { Cart.publish(cart); }).catch(function () {});
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Theme editor lifecycle
  document.addEventListener('shopify:section:load', function (e) {
    initCards(e.target);
    initRelated(e.target);
    initReveal();
    initTray();
    initCartPage();
    initSearch();
    initFacets();
  });
})();
